/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/teamaccount-list.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('TeamAccountInfoListCtrl', ['$q', '$scope', '$location', '$stateParams', '$filter', '$state', 'UserInfoPreload', 'auiDialog', 'OpenApp', 'auiTeamAccountService', 'OpenOther', '$rootScope', 'userAuth',
        function ($q, $scope, $location, $stateParams, $filter, $state, UserInfoPreload, auiDialog, OpenApp, auiTeamAccountService, OpenOther, $rootScope, userAuth) {
            var Model = $scope.Model = {};
            var DateFilter = {
                fromTime: new Date(),
                toTime: new Date()
            }
            Model.constant = {};
            Model.constant.statusType = mainCons.teamMemberConstant.statusType;
            Model.constant.roleType = mainCons.teamMemberConstant.roleType;
            var inviteDateFilterParams = "";
            var expiryDateFilterParams = "";
            Model.verifyRealState = UserInfoPreload.verifyRealState;
            Model.userType = UserInfoPreload.userType;
            Model.agcTeamRoleToID = sysParamCfg.agcTeamRoleToID;
            Model.showMsgLang = true;
            Model.isMemberAccountDetail = (($location.url().split('/')[2] == 'memberAccountDetail' || $location.url().split('/')[2] == 'teamAccountInfoList')) && ($location.url().split('/')[1] == 'mysetting');
            // 通知消息语种
            $scope.notifyMsgLangList = sysParamCfg.displaylangCountries;
            Model.account = {
                tableHeader: {
                    accountName: {
                        id: "accountName",
                        name: "华为帐号",
                        width: 210,
                        maxlength: 128,
                        filterMethod: queryIdSearchList,
                        queryMethod: queryListSec
                    },
                    memberNickName: {
                        id: "memberNickName",
                        name: "昵称",
                        maxlength: 20,
                        filterMethod: queryNameSearchList,
                        queryMethod: queryListSec
                    },
                    status: {
                        id: "status",
                        name: "状态",
                        data: [{id: '1', name: '邀请中'}, {id: '2', name: '邀请失败'}, {
                            id: '3',
                            name: '已激活'
                        }, {
                            id: '4',
                            name: '已失效'
                        }],
                        queryMethod: queryListSec
                    },
                    inviteDateFilter: {
                        id: "inviteDateFilter",
                        name: "邀请时间",
                        queryMethod: queryListInvite
                    },
                    expiryDateFilter: {
                        id: "expiryDateFilter",
                        name: "到期日期",
                        queryMethod: queryListExpiry
                    }
                },
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        totalCount: 0,
                        noItems: "No data",
                        pagesLength: 10,// 显示的页码数量,
                        onChange: queryList
                    },
                    tableHeader: {
                        accountName: "",
                        memberNickName: "",
                        status: [],
                        inviteDateFilter: {
                            /* sortType: 1,//1:按顺序 ， 2：按时间区间
                             sortOrder: 1,//0:按时间新到旧  1：按时间旧到新*/
                            fromTime: new Date(),
                            toTime: new Date()
                        },
                        expiryDateFilter: {
                            /* sortType: 1,//1:按顺序 ， 2：按时间区间
                             sortOrder: 1,//0:按时间新到旧  1：按时间旧到新*/
                            fromTime: new Date(),
                            toTime: new Date()
                        },
                        updateDateFilter: {
                            sortType: 1,//1:按顺序 ， 2：按时间区间
                            sortOrder: 1,//0:按时间新到旧  1：按时间旧到新
                            fromTime: new Date(),
                            toTime: new Date()
                        }
                    }
                },
                columns: [//列表栏
                    {
                        columnField: '华为帐号', columnWidth: '13%'
                    }, {
                        columnField: '昵称', columnWidth: '10%'
                    }, {
                        columnField: '角色', columnWidth: '8%'
                    }, {
                        columnField: 'Apps', columnWidth: '13%'
                    }, {
                        columnField: '状态', columnWidth: '10%'
                    }, {
                        columnField: '邀请时间', columnWidth: '16%'
                    }, {
                        columnField: '到期日期', columnWidth: '10%'
                    }, {
                        columnField: '操作', columnWidth: '20%'
                    }

                ]
            };
            //函数区
            $scope.contains = contains;
            $scope.queryList = queryList;
            $scope.addMemberAccount = addMemberAccount;
            $scope.accountDetail = accountDetail;
            $scope.updateMember = updateMember;
            $scope.deleteMember = deleteMember;
            $scope.reInvitingMember = reInvitingMember;

            //修改成员帐号信息
            function updateMember(row) {
                auiTeamAccountService.getMemberAccountDetail(row.fakeMemberID).then(function (data) {
                    $state.go("mysetting.addMemberAccount.account", {
                        teamMemberInfo: data.teamMemberInfo,
                        memberResInfo: data.memberResInfo
                    });
                });
            }

            //修改成员帐号信息
            function deleteMember(row) {
                var deleteTip = row.teamMemberInfo.memberState == 1 || row.teamMemberInfo.memberState == 2 ? ("<div class='wid-240px'>您确认要删除 " + row.teamMemberInfo.memberLoginName + " 帐号吗？</div> ") : (" <div class='wid-240px'>您确认要删除 " + row.teamMemberInfo.memberLoginName + " 帐号吗？</div>" + "<p class='mt-1 wid-240px'>帐号删除后，该帐号相关的数据也将被删除。</p>");
                auiDialog.confirm("删除帐号", deleteTip, function () {
                    auiTeamAccountService.deleteMemberAccount(row.teamMemberInfo.fakeMemberID).then(function () {
                        auiDialog.success("删除成功", function () {
                            queryList();
                        });
                    })
                });
            }

            //重新邀请
            function reInvitingMember(row) {
                row.showMsgLang = Model.showMsgLang;
                row.isMemberAccountDetail = Model.isMemberAccountDetail;
                //暂时先塞row 进去。等appID上线了再去查找。
                auiTeamAccountService.reInvitingMemberAccount(row, $scope.notifyMsgLangList).then(function () {
                    queryList();
                });
            }


            //查询成员帐号详情
            function accountDetail(row) {
                //暂时先塞row 进去。等appID上线了再去查找。
                $state.go('mysetting.memberAccountDetail', {
                    fakeMemberID: row.teamMemberInfo.fakeMemberID
                });
            }

            //添加成员帐号
            function addMemberAccount() {
                if ($scope.totalCount == 0) {
                    auiDialog.confirm("潜在的跨境转移", "您的姓名、地址、联系方式、商户信息将被您邀请的成员查看（包含跨境成员）。点击“确定”后，默认您同意以上信息被团队内所有成员查看，创建成员成功后此提示将不会再次出现。", function () {
                        $state.go("mysetting.addMemberAccount.account");
                    });
                } else {
                    $state.go("mysetting.addMemberAccount.account");
                }

            }

            function queryIdSearchList() {
                var defer = $q.defer();
                querySearchList('memberLoginName').then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }

            function queryNameSearchList() {
                var defer = $q.defer();
                querySearchList('memberNickName').then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }

            //查询列表
            function querySearchList(type) {
                var defer = $q.defer();
                var getSearchListRequest = {};
                //不带分页事件的查询
                getSearchListRequest.req = {
                    memberLoginName: Model.account.query.tableHeader.accountName,
                    searchText: Model.account.query.tableHeader.memberNickName,
                    lang: 'zh_CN'
                };

                OpenOther.getMemberRoleList(getSearchListRequest).then(function (data) {
                    var result = [];
                    var teamMemberResList = data && data.teamMemberRoleInfoList;
                    if (teamMemberResList && teamMemberResList.length > 0) {
                        for (var i in teamMemberResList) {
                            result.push(teamMemberResList[i].teamMemberInfo[type]);
                        }
                    }
                    defer.resolve(AUI.BaseJSUtil.unique(result));
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


            function queryListSec() {
                queryList('two');
            }


            function queryListInvite() {
                if (!Model.account.tableHeader.inviteDateFilter.inviteDateFilterFlag) return;
                if (inviteDateFilterParams == angular.toJson(Model.account.query.tableHeader.inviteDateFilter)) return;
                inviteDateFilterParams = angular.toJson(Model.account.query.tableHeader.inviteDateFilter);
                queryList('two', 'inviteDateFilter').then(function () {
                    Model.account.tableHeader.expiryDateFilter.expiryDateFilterFlag = false;
                    expiryDateFilterParams = "";
                    Model.account.query.tableHeader.expiryDateFilter = angular.copy(DateFilter);
                })
            }

            function queryListExpiry() {
                if (!Model.account.tableHeader.expiryDateFilter.expiryDateFilterFlag) return;
                if (expiryDateFilterParams == angular.toJson(Model.account.query.tableHeader.expiryDateFilter)) return;
                expiryDateFilterParams = angular.toJson(Model.account.query.tableHeader.expiryDateFilter);
                queryList('two', 'expiryDateFilter').then(function () {
                    Model.account.tableHeader.inviteDateFilter.inviteDateFilterFlag = false;
                    inviteDateFilterParams = "";
                    Model.account.query.tableHeader.inviteDateFilter = angular.copy(DateFilter);
                })
            }


            //调用产品列表接口
            function queryList(value, type) {
                var defer = $q.defer();
                if (!type && !Model.account.tableHeader.inviteDateFilter.inviteDateFilterFlag && !Model.account.tableHeader.expiryDateFilter.expiryDateFilterFlag) {
                    type = 'updateDateFilter';
                } else if (!type && Model.account.tableHeader.inviteDateFilter.inviteDateFilterFlag) {
                    type = 'inviteDateFilter';
                } else if (!type && Model.account.tableHeader.expiryDateFilter.expiryDateFilterFlag) {
                    type = 'expiryDateFilter';
                }
                var getProductListRequest = {};
                //带分页事件的查询
                var request = {
                    fromRecCount: 1 + (Model.account.query.pagination.currentPage - 1) * Model.account.query.pagination.itemsPerPage,
                    maxReqCount: Model.account.query.pagination.itemsPerPage,
                    sortType: Model.account.query.tableHeader[type].sortOrder,
                    memberLoginName: Model.account.query.tableHeader.accountName,
                    searchText: Model.account.query.tableHeader.memberNickName,
                    fromTime: $filter('date')(($filter('auiDateFormat')($filter('date')(Model.account.query.tableHeader[type].fromTime, 'yyyy-MM-dd 00:00:00'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd HH:mm:ss'),
                    toTime: $filter('date')(($filter('auiDateFormat')($filter('date')(Model.account.query.tableHeader[type].toTime, 'yyyy-MM-dd 23:59:59'), new Date().toString().split(' ')[5].split('GMT')[1], '+0000')), 'yyyy-MM-dd HH:mm:ss'),
                    lang: 'zh_CN',
                    timeType: type == 'inviteDateFilter' ? 2 : (type == 'expiryDateFilter' ? 3 : 1)
                };
                if (Model.account.query.tableHeader.status.length > 0) {
                    request.memberStateList = Model.account.query.tableHeader.status.join(',').split(',');
                }
                if (angular.toJson(request.memberLoginName) == '') {
                    delete request.memberLoginName;
                }
                if (angular.toJson(request.searchText) == '') {
                    delete request.searchText;
                }
                if (Model.account.query.tableHeader[type].sortType == 1) {
                    delete request.fromTime;
                    delete request.toTime;
                }
                if (request.fromTime && request.toTime) {
                    request.sortType = 1;
                }

                if ((request.memberTypeList || request.memberStateList || request.searchTxt || (request.fromTime && request.toTime) || request.sortType == 0 || request.sortType) && value == 'two') {
                    request.fromRecCount = 1;
                    Model.account.query.pagination.currentPage = 1;
                }
                getProductListRequest.req = request;
                Model.account.productList = null;
                OpenOther.getMemberRoleList(getProductListRequest).then(function (data) {
                    Model.account.productList = data.teamMemberRoleInfoList;
                    $scope.productList = angular.copy(data.teamMemberRoleInfoList);
                    auiTeamAccountService.getMemberAccountDetailList(Model.account.productList);
                    if (value == 'first') {
                        $scope.totalCount = data.totalCount;
                    }
                    if (data.totalCount == 0) {
                        Model.account.productList = [];
                    }
                    Model.account.query.pagination.totalCount = data.totalCount;
                    defer.resolve(data);
                }).catch(function () {
                    Model.account.productList = [];
                    defer.resolve();
                });
                return defer.promise;
            }

            //包含
            function contains(arr, obj) {
                return AUI.BaseJSUtil.contains(arr, obj);
            }

            $rootScope.checkState($state).then(function () {
                if ($scope.mainUserID) {
                    auiTeamAccountService.getAppServiceUserRole().then(function (AppServiceRoleList) {
                        Model.serviceIsAdmin = AUI.BaseJSUtil.contains(AppServiceRoleList, Model.agcTeamRoleToID.manager) || AUI.BaseJSUtil.contains(AppServiceRoleList, Model.agcTeamRoleToID.appManager);
                        auiTeamAccountService.getCurrentUserRole().then(function (teamRoleList) {
                            Model.currUserIsAdmin = AUI.BaseJSUtil.contains(teamRoleList, 'Admin');
                            queryList('first');
                        })
                    });
                } else {
                    queryList('first');
                }
            });

        }]);
});

